import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  TeiHubLinkDispatchMultipleResponse,
  TeiHubLinkDispatchMultipleRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkDispatchMultiple {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkDispatchMultiple;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkDispatchMultiple.initial,
  message: "",
};

export const teiHubLinkDispatchMultiple = createAsyncThunk(
  "teiHubLinkDispatchMultiple",
  async (param: { id: string[] }, { rejectWithValue }) => {
    try {
      const response: TeiHubLinkDispatchMultipleResponse =
        await TeiHubLinkDispatchMultipleRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkDispatchMultipleSlice = createSlice({
  name: "teiHubLinkDispatchMultiple",
  initialState,
  reducers: {
    resetTeiHubLinkDispatchMultiple: (state) => {
      state.status = TeiHubLinkDispatchMultiple.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkDispatchMultiple.pending, (state) => {
        state.status = TeiHubLinkDispatchMultiple.inProgress;
      })
      .addCase(teiHubLinkDispatchMultiple.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkDispatchMultiple.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkDispatchMultiple.rejected, (state, action) => {
        state.status = TeiHubLinkDispatchMultiple.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkDispatchMultiple = (state: RootState) =>
  state.teiHubLinkDispatchMultiple;

export const { resetTeiHubLinkDispatchMultiple } =
  teiHubLinkDispatchMultipleSlice.actions;
export default teiHubLinkDispatchMultipleSlice.reducer;
